/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class RepositoriesApi extends runtime.BaseAPI {
    /**
     * Get a paginated list of repositories. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async repositoriesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling repositoriesGet.');
        }
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of repositories. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async repositoriesGet(requestParameters, initOverrides) {
        const response = await this.repositoriesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new repository.
     */
    async repositoriesPostRaw(requestParameters, initOverrides) {
        if (requestParameters.contentRepositoryInsert === null ||
            requestParameters.contentRepositoryInsert === undefined) {
            throw new runtime.RequiredError('contentRepositoryInsert', 'Required parameter requestParameters.contentRepositoryInsert was null or undefined when calling repositoriesPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentRepositoryInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new repository.
     */
    async repositoriesPost(requestParameters, initOverrides) {
        const response = await this.repositoriesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a repository.
     */
    async repositoriesRepositoryIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}`.replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a repository.
     */
    async repositoriesRepositoryIdDelete(requestParameters, initOverrides) {
        await this.repositoriesRepositoryIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a repository.
     */
    async repositoriesRepositoryIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}`.replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a repository.
     */
    async repositoriesRepositoryIdGet(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of guests.
     */
    async repositoriesRepositoryIdGuestsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdGuestsGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling repositoriesRepositoryIdGuestsGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/guests`.replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of guests.
     */
    async repositoriesRepositoryIdGuestsGet(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdGuestsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a guest.
     */
    async repositoriesRepositoryIdGuestsGuestIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdGuestsGuestIdGet.');
        }
        if (requestParameters.guestId === null ||
            requestParameters.guestId === undefined) {
            throw new runtime.RequiredError('guestId', 'Required parameter requestParameters.guestId was null or undefined when calling repositoriesRepositoryIdGuestsGuestIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/guests/{guestId}`
                .replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId))
                .replace(`{${'guestId'}}`, String(requestParameters.guestId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a guest.
     */
    async repositoriesRepositoryIdGuestsGuestIdGet(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdGuestsGuestIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of invitations.
     */
    async repositoriesRepositoryIdInvitationsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdInvitationsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/invitations`.replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of invitations.
     */
    async repositoriesRepositoryIdInvitationsGet(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdInvitationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an invitation.
     */
    async repositoriesRepositoryIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdInvitationsInvitationIdDelete.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling repositoriesRepositoryIdInvitationsInvitationIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/invitations/{invitationId}`
                .replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an invitation.
     */
    async repositoriesRepositoryIdInvitationsInvitationIdDelete(requestParameters, initOverrides) {
        await this.repositoriesRepositoryIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an invitation.
     */
    async repositoriesRepositoryIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdInvitationsInvitationIdGet.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling repositoriesRepositoryIdInvitationsInvitationIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/invitations/{invitationId}`
                .replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an invitation.
     */
    async repositoriesRepositoryIdInvitationsInvitationIdGet(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an invitation.
     */
    async repositoriesRepositoryIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling repositoriesRepositoryIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.contentRepositoryRoleRamInvitationEdit === null ||
            requestParameters.contentRepositoryRoleRamInvitationEdit === undefined) {
            throw new runtime.RequiredError('contentRepositoryRoleRamInvitationEdit', 'Required parameter requestParameters.contentRepositoryRoleRamInvitationEdit was null or undefined when calling repositoriesRepositoryIdInvitationsInvitationIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/invitations/{invitationId}`
                .replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentRepositoryRoleRamInvitationEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an invitation.
     */
    async repositoriesRepositoryIdInvitationsInvitationIdPatch(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new invitation.
     */
    async repositoriesRepositoryIdInvitationsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdInvitationsPost.');
        }
        if (requestParameters.contentRepositoryRoleRamInvitationInsert === null ||
            requestParameters.contentRepositoryRoleRamInvitationInsert === undefined) {
            throw new runtime.RequiredError('contentRepositoryRoleRamInvitationInsert', 'Required parameter requestParameters.contentRepositoryRoleRamInvitationInsert was null or undefined when calling repositoriesRepositoryIdInvitationsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/invitations`.replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentRepositoryRoleRamInvitationInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new invitation.
     */
    async repositoriesRepositoryIdInvitationsPost(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdInvitationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of members.
     */
    async repositoriesRepositoryIdMembersGetRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdMembersGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling repositoriesRepositoryIdMembersGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/members`.replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of members.
     */
    async repositoriesRepositoryIdMembersGet(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdMembersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a member.
     */
    async repositoriesRepositoryIdMembersMemberIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdMembersMemberIdDelete.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling repositoriesRepositoryIdMembersMemberIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/members/{memberId}`
                .replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a member.
     */
    async repositoriesRepositoryIdMembersMemberIdDelete(requestParameters, initOverrides) {
        await this.repositoriesRepositoryIdMembersMemberIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a member.
     */
    async repositoriesRepositoryIdMembersMemberIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdMembersMemberIdGet.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling repositoriesRepositoryIdMembersMemberIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/members/{memberId}`
                .replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a member.
     */
    async repositoriesRepositoryIdMembersMemberIdGet(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdMembersMemberIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a member.
     */
    async repositoriesRepositoryIdMembersMemberIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdMembersMemberIdPatch.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling repositoriesRepositoryIdMembersMemberIdPatch.');
        }
        if (requestParameters.contentRepositoryRoleRamMemberEdit === null ||
            requestParameters.contentRepositoryRoleRamMemberEdit === undefined) {
            throw new runtime.RequiredError('contentRepositoryRoleRamMemberEdit', 'Required parameter requestParameters.contentRepositoryRoleRamMemberEdit was null or undefined when calling repositoriesRepositoryIdMembersMemberIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/members/{memberId}`
                .replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentRepositoryRoleRamMemberEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a member.
     */
    async repositoriesRepositoryIdMembersMemberIdPatch(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdMembersMemberIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new member.
     */
    async repositoriesRepositoryIdMembersPostRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdMembersPost.');
        }
        if (requestParameters.contentRepositoryRoleRamMemberInsert === null ||
            requestParameters.contentRepositoryRoleRamMemberInsert === undefined) {
            throw new runtime.RequiredError('contentRepositoryRoleRamMemberInsert', 'Required parameter requestParameters.contentRepositoryRoleRamMemberInsert was null or undefined when calling repositoriesRepositoryIdMembersPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}/members`.replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentRepositoryRoleRamMemberInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new member.
     */
    async repositoriesRepositoryIdMembersPost(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdMembersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a repository.
     */
    async repositoriesRepositoryIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.repositoryId === null ||
            requestParameters.repositoryId === undefined) {
            throw new runtime.RequiredError('repositoryId', 'Required parameter requestParameters.repositoryId was null or undefined when calling repositoriesRepositoryIdPatch.');
        }
        if (requestParameters.contentRepositoryEdit === null ||
            requestParameters.contentRepositoryEdit === undefined) {
            throw new runtime.RequiredError('contentRepositoryEdit', 'Required parameter requestParameters.contentRepositoryEdit was null or undefined when calling repositoriesRepositoryIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/repositories/{repositoryId}`.replace(`{${'repositoryId'}}`, String(requestParameters.repositoryId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contentRepositoryEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a repository.
     */
    async repositoriesRepositoryIdPatch(requestParameters, initOverrides) {
        const response = await this.repositoriesRepositoryIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const RepositoriesGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const RepositoriesRepositoryIdGuestsGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
/**
 * @export
 */
export const RepositoriesRepositoryIdMembersGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
//# sourceMappingURL=RepositoriesApi.js.map